import React from 'react'

import {
  arrayOf,
  object,
  string,
  shape,
  func,
  node,
  oneOf,
} from 'prop-types'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import TableBody from './Components/TableBody'
import { TableHeader } from './Components/TableHeader'
import { useTableData } from './hooks/useTableData'

function LegacyDataTable({
  data = EMPTY_ARRAY,
  className = '',
  EmptyMessage = null,
  renderCustomCell = EMPTY_OBJECT,
  columnsConfig = EMPTY_OBJECT,
  sortKey = null,
  sortDirection = null,
  onSort = null,
}) {
  const { columns, validRows } = useTableData(data, columnsConfig)

  if (!validRows.length) {
    return EmptyMessage
  }

  return (
    <div className={`data-table ${className}`}>
      <table>
        <colgroup>
          {columns.map((col, index) => (
            <col
              key={col.key || col.id || col.title || col.dataIndex || index}
              style={{
                width: col.width || 'auto',
                ...(col.width && col.width !== 'auto' && {
                  minWidth: col.width,
                  maxWidth: col.width,
                }),
              }}
            />
          ))}
        </colgroup>
        <TableHeader
          columns={columns}
          sortKey={sortKey}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <TableBody
          columns={columns}
          rows={validRows}
          renderCustomCell={renderCustomCell}
        />
      </table>
    </div>
  )
}

LegacyDataTable.propTypes = {
  data: arrayOf(object).isRequired,
  className: string,
  EmptyMessage: node,
  renderCustomCell: shape({
    [string]: func,
  }),
  columnsConfig: shape({
    [string]: shape({
      tooltip: string,
    }),
  }),
  sortKey: string,
  sortDirection: oneOf(['asc', 'desc']),
  onSort: func,
}

export default LegacyDataTable
